module.exports = __webpack_public_path__ + "img/18_27.c9bc29c1.png";